<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:20:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 11:16:29
 * @FilePath: \mrc-base-server-view\src\views\data-stored-procedure\detail\index.vue
-->
<template>
  <div>
    <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :showEdit="
          hasBtn('edit-stored-procedure') &&
            editPermission(params.org_level_uuid)
        "
                         :show_del="
          hasBtn('delete-stored-procedure') &&
            editPermission(params.org_level_uuid)
        "
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"
                         @handleDel="handleDel"></mrc_ess_iconGroup>
      <data-info @success="success"
                 @changeReadonly='changeReadonly'
                 :loading="loading"
                 :paramsProps="params"
                 :disabled="disabled"></data-info>
    </mrc_ess_skeleton_loader>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  getProcedureInfo,
  addUpdateProcedure,
  delProcedure,
} from '@/service/api/dataStoredProcedure'
import dataInfo from '../modules/index'
export default {
  components: { dataInfo },
  props: {},
  data () {
    return {
      loading: false,
      skeletonloading: true,
      params: {
        procedure_name: '',
        procedure_description: '',
        procedure_sql: '',
        para_name: '',
        para_desc: '',
      },
      disabled: false,
    }
  },
  validations: {},
  computed: {},
  created () { },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_stored_procedure'
          this.$store.commit('set_page_title', 'label_edit_stored_procedure')
        }
        else {
          this.$route.meta.title = 'label_view_stored_procedure'
          this.$store.commit('set_page_title', 'label_view_stored_procedure')
        }
      }, immediate: true
    }
  },
  async mounted () {
    if (this.$store.state.iconstatus) {
      this.disabled = true
    } else {
      this.disabled = false
    }
    await this.getInfo()
  },

  methods: {
    editPermission (uuid) {
      if (this.$store.state.userData.userType == 1) {
        if (uuid && uuid.length > 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    async getInfo () {
      this.skeletonloading = true
      const res = await getProcedureInfo({
        uuid: this.$store.state.uuid,
      })
      if (res.code == 200) {
        this.params = res.data
      }
      this.skeletonloading = false
    },
    async success (params) {
      this.loading = true
      try {
        const res = await addUpdateProcedure(params)
        if (res.code == 200) {
          this.$Message({
            text: this.$t('message_The_modification_was_successful'),
          })
          this.loading = false
          // this.$router.go(-1)
          this.disabled = !this.disabled
        }
      } catch (err) {
        this.loading = false
      }
    },
    async changeReadonly () {
      this.handleEdit()
      await this.getInfo()
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
        .then(async () => {
          const del = await delProcedure({
            uuid: this.$store.state.uuid,
          })
          if (del.code == 200) {
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
            this.$router.push({
              name: 'data-stored-procedure',
              params: {
                type: 'del',
              },
            })
          }
        })
        .catch(() => { })
    },
  },
}
</script>

<style scoped></style>
